export default [
  {
    path: '/generated-links',
    name: 'PageGeneratedLinksList',
    meta: { title: 'generatedLinks.listTitle', roles: ['ADMIN'], permissions: ['link_generator'] },
    component: () => import('@/pages/generated-links'),
  },
  {
    path: '/generated-links/:id/edit',
    name: 'PageGeneratedLinksEdit',
    meta: { title: 'generatedLinks.editFormTitle', roles: ['ADMIN'], permissions: ['link_generator'] },
    component: () => import('@/pages/generated-links/id/edit'),
  },
]
